var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded"},[_c('vue-flux',{ref:"slider",attrs:{"options":_vm.vfOptions,"images":_vm.urls,"transitions":_vm.vfTransitions},scopedSlots:_vm._u([{key:"controls",fn:function(){return [_c('flux-controls')]},proxy:true},{key:"index",fn:function(){return [_c('flux-index')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }